export const company = {
  name: 'Asset Hound Limited',
  number: '17284294',
  jurisdiction: 'England and Wales',
  registeredOffice:
    '3 Greengate, Cardale Park, Harrogate, United Kingdom, HG3 1GY',
  email: 'support@assethound.uk',
  registerUrl:
    'https://find-and-update.company-information.service.gov.uk/company/17284294',
} as const;
